const API_URL = process.env.REACT_APP_BACKEND_URL;
const seen = new Set();

export const reportError = (message, stack = '', kind = 'js_error') => {
  try {
    const key = `${kind}:${String(message).slice(0, 120)}`;
    if (seen.has(key) || seen.size > 25) return;
    seen.add(key);
    fetch(`${API_URL}/api/errors/report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        message: String(message).slice(0, 500),
        stack: String(stack || '').slice(0, 4000),
        path: window.location.pathname,
        kind,
      }),
    }).catch(() => {});
  } catch { /* never break the app from the reporter */ }
};

export const installCrashReporter = () => {
  const selfHeal = (msg) => {
    if (/ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module/i.test(msg || '')) {
      import('../components/ErrorBoundary').then((m) => m.autoFixStaleBuild()).catch(() => {});
    }
  };
  window.addEventListener('error', (e) => {
    reportError(e.message || 'Unknown error', e.error?.stack, 'js_error');
    selfHeal(`${e.error?.name || ''} ${e.message || ''}`);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    reportError(r?.message || String(r).slice(0, 200), r?.stack, 'unhandled_rejection');
    selfHeal(`${r?.name || ''} ${r?.message || ''}`);
  });
};
